import morphism, { createSchema } from 'morphism';

export const automationResponseSchema = createSchema(
  {
    code: 'code',
    contacts: 'contacts',
    activatedAt: 'activatedAt',
    createdAt: 'createdAt',
    createdBy: 'createdBy',
    deleted: 'deleted',
    experienceSettings: source =>
      source.experienceSettings
        ? {
            ...source.experienceSettings,
            branding: source.experienceSettings?.branding?.giftWrapperUrl
              ? source.experienceSettings?.branding
              : undefined,
            messageParams: Object.keys(source.experienceSettings?.messageParams || {}).length
              ? {
                  message: source.experienceSettings.messageParams?.message || undefined,
                  senderName: source.experienceSettings.messageParams?.senderName || undefined,
                  aboutMessage: source.experienceSettings.messageParams?.aboutMessage || undefined,
                  customizedRecipientMessages:
                    Object.keys(
                      source.experienceSettings.messageParams?.customizedRecipientMessages || {}
                    ).length > 0
                      ? source.experienceSettings.messageParams?.customizedRecipientMessages
                      : undefined
                }
              : undefined,
            sharingMethod: Object.keys(source.experienceSettings?.sharingMethod || {}).length
              ? {
                  params: {
                    subject: source.experienceSettings.sharingMethod?.params?.subject || undefined
                  }
                }
              : undefined
          }
        : undefined,
    id: 'id',
    link: 'link',
    meta: 'meta',
    name: 'name',
    paymentMethod: 'paymentMethod',
    acceptanceRates: 'acceptanceRates',
    merchantOrder: 'merchantOrder',
    products: source =>
      source?.products?.map?.(product => ({
        id: product.merchantProductId,
        merchantProductId: product.merchantProductId,
        images:
          product?.images?.map(image => ({
            default: image?.default,
            full: image?.full,
            thumb: image?.thumb,
            url: image?.url
          })) || undefined,
        source: product?.source || undefined,
        name: product?.name,
        brand: product?.brand,
        prices: product.prices,
        skus: product.skus.map(sku => ({
          code: sku.code,
          price: sku.price,
          priceBreakdown: sku.priceBreakdown,
          regularPrice: sku.regularPrice,
          meta: sku.meta
        })),
        meta: product?.meta
      })),
    settings: 'settings',
    addons: source => source.addons.map?.(addon => ({ type: addon.type, data: addon.data })),
    status: 'status',
    type: 'type',
    updatedAt: 'updatedAt'
  },
  { undefinedValues: { strip: true } }
);

export default {
  automation: createSchema(automationResponseSchema, { undefinedValues: { strip: true } }),
  list: createSchema(
    {
      docs: source => morphism(automationResponseSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  )
};
